import { RouteObject } from "react-router";
import SharedGuard from "routes/guards/shared";
import SharedListProvider from "providers/shared-list";
import SharedUserProvider from "providers/shared-user";
import SharedListUserView from "views/shared/list/user/view";
import SharedListView from "views/shared/list/view";

export const sharedRoutes: RouteObject[] = [
  {
    // start with nested routing
    path: "shared",
    children: [
      // guarded routes
      {
        element: <SharedGuard />,
        children: [
          {
            path: "list/:listUuid",
            element: <SharedListProvider />,
            children: [
              { index: true, element: <SharedListView /> },
              {
                path: "user/:userUuid",
                element: <SharedUserProvider />,
                children: [{ index: true, element: <SharedListUserView /> }],
              },
            ],
          },
        ],
      },
    ],
  },
];
